var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInsert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "945px",
    height: "945px",
    viewBox: "0 0 945 945",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CheckInsert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckInsert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.234165,588.772818 C695.454894,577.535991 664.708734,577.025773 645.557695,587.635102 C626.406656,598.244431 626.11527,615.954714 644.894542,627.191541 C663.683862,638.429371 694.088398,638.947608 713.591109,628.554796 C735.033038,617.128516 733.013437,600.010648 714.234165,588.772818",
    id: "Check-Insert",
    fill: "#1A3482"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInsert);
export default __webpack_public_path__ + "static/media/CheckInsert.8f855c4f9a6d5159b037956af89f79c6.svg";
export { ForwardRef as ReactComponent };